import { toast } from "react-toastify";
import { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Button, Spinner } from "react-bootstrap-v5";
import { CategoryService } from "../../Services";

export const AddCategory = ({ setAddModal, getDetail }) => {
  const [, setForceUpdate] = useState("");
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    category_name: "",
  });

  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = () => {
    let validate = Validator.current.allValid();
    if (validate) {
      setLoader(true);
      CategoryService.addCategory(state).then((res) => {
        if (res.status) {
          toast.success(res.message)
          setLoader(false);
          getDetail();
          setAddModal(false);
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    } else {
      Validator.current.showMessages();
    }
  };

  return (
    <div>
      <div className="mb-3 col-12">
        <input
          type="text"
          className="form-control"
          name="category_name"
          value={state.category_name}
          placeholder="Name"
          onChange={(e) => handleChange(e)}
        />
        {Validator.current.message(
          "Category name",
          state.category_name,
          "required",
          { className: "text-danger" }
        )}
      </div>
      <div>
        <Button
          type="submit"
          className="mt-2 mx-auto d-block w-25"
          onClick={handleSubmit}
        >
          {(loader && <Spinner animation="grow" size="sm" />) || "Save"}
        </Button>
      </div>
    </div>
  );
};
